function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdfEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2481px",
    height: "3508px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 826.5,-0.5 1653.5,-0.5 2480.5,-0.5C 2480.5,1168.83 2480.5,2338.17 2480.5,3507.5C 1653.5,3507.5 826.5,3507.5 -0.5,3507.5C -0.5,2338.17 -0.5,1168.83 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e14699",
    d: "M 1354.5,1308.5 C 1331.94,1329.22 1310.11,1350.89 1289,1373.5C 1270.41,1394.42 1253.74,1416.75 1239,1440.5C 1215.67,1403.48 1188.17,1369.64 1156.5,1339C 1145.27,1328.27 1133.94,1317.77 1122.5,1307.5C 1127.37,1276.05 1139.87,1248.05 1160,1223.5C 1182.17,1195.98 1208.5,1173.65 1239,1156.5C 1266.81,1171.45 1290.14,1191.78 1309,1217.5C 1329.46,1245.08 1344.62,1275.41 1354.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 1122.5,1307.5 C 1133.94,1317.77 1145.27,1328.27 1156.5,1339C 1188.17,1369.64 1215.67,1403.48 1239,1440.5C 1253.74,1416.75 1270.41,1394.42 1289,1373.5C 1310.11,1350.89 1331.94,1329.22 1354.5,1308.5C 1419.49,1254.15 1489.82,1207.48 1565.5,1168.5C 1569.95,1195.12 1571.95,1221.96 1571.5,1249C 1571.55,1281.64 1569.55,1314.14 1565.5,1346.5C 1498.29,1373.99 1436.29,1409.83 1379.5,1454C 1363.4,1467.27 1348.06,1481.44 1333.5,1496.5C 1297.94,1465.43 1256.61,1453.6 1209.5,1461C 1191.54,1464.54 1174.87,1471.21 1159.5,1481C 1153.68,1484.99 1148.35,1489.49 1143.5,1494.5C 1096.5,1448 1043.5,1409.83 984.5,1380C 960.199,1367.68 935.532,1356.18 910.5,1345.5C 903.59,1290.27 902.756,1234.93 908,1179.5C 908.264,1175.04 909.098,1170.71 910.5,1166.5C 986.696,1205.57 1057.36,1252.57 1122.5,1307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e14699",
    d: "M 910.5,1345.5 C 935.532,1356.18 960.199,1367.68 984.5,1380C 1043.5,1409.83 1096.5,1448 1143.5,1494.5C 1169.97,1522.84 1191.14,1554.84 1207,1590.5C 1217.58,1615.13 1222.91,1640.8 1223,1667.5C 1219.9,1683.81 1211.4,1687.64 1197.5,1679C 1193.3,1675.13 1189.47,1670.97 1186,1666.5C 1170.65,1642.47 1154.32,1619.13 1137,1596.5C 1128.96,1586.96 1120.13,1578.29 1110.5,1570.5C 1089.8,1551.65 1066.13,1538.32 1039.5,1530.5C 1026.73,1550.86 1022.9,1572.86 1028,1596.5C 1033.82,1619.48 1044.82,1639.48 1061,1656.5C 1081.72,1677.92 1104.88,1696.09 1130.5,1711C 1159.17,1727 1187.83,1743 1216.5,1759C 1226.06,1769.94 1233.72,1782.11 1239.5,1795.5C 1245.77,1782.41 1253.44,1770.24 1262.5,1759C 1287.17,1745.33 1311.83,1731.67 1336.5,1718C 1366.96,1701.17 1394.46,1680.34 1419,1655.5C 1436.71,1636.09 1448.04,1613.42 1453,1587.5C 1454.87,1566.8 1450.37,1547.63 1439.5,1530C 1411.31,1538.59 1386.64,1553.09 1365.5,1573.5C 1360.57,1576.92 1356.07,1580.92 1352,1585.5C 1331.4,1609.77 1312.73,1635.43 1296,1662.5C 1291.91,1668.59 1287.08,1674.09 1281.5,1679C 1271.3,1686.59 1263.47,1684.76 1258,1673.5C 1256.11,1669.91 1255.27,1666.08 1255.5,1662C 1258.81,1621.41 1271.31,1583.91 1293,1549.5C 1305.18,1530.82 1318.68,1513.15 1333.5,1496.5C 1348.06,1481.44 1363.4,1467.27 1379.5,1454C 1436.29,1409.83 1498.29,1373.99 1565.5,1346.5C 1636.95,1316.21 1710.62,1292.55 1786.5,1275.5C 1787.5,1275.83 1788.5,1276.17 1789.5,1276.5C 1775.89,1327.84 1757.05,1377.17 1733,1424.5C 1695.72,1496.09 1651.72,1563.09 1601,1625.5C 1568.45,1661.74 1530.95,1691.57 1488.5,1715C 1410.14,1757.12 1326.97,1785.29 1239,1799.5C 1141.23,1783.92 1050.06,1750.75 965.5,1700C 933.051,1679.23 903.884,1654.4 878,1625.5C 814.006,1547.73 761.672,1462.39 721,1369.5C 707.925,1339.11 697.758,1307.77 690.5,1275.5C 765.947,1292.2 839.281,1315.54 910.5,1345.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1333.5,1496.5 C 1318.68,1513.15 1305.18,1530.82 1293,1549.5C 1271.31,1583.91 1258.81,1621.41 1255.5,1662C 1255.27,1666.08 1256.11,1669.91 1258,1673.5C 1263.47,1684.76 1271.3,1686.59 1281.5,1679C 1287.08,1674.09 1291.91,1668.59 1296,1662.5C 1312.73,1635.43 1331.4,1609.77 1352,1585.5C 1356.07,1580.92 1360.57,1576.92 1365.5,1573.5C 1363.28,1600.33 1354.78,1625 1340,1647.5C 1331.49,1659.86 1322.49,1671.86 1313,1683.5C 1290,1707.17 1267,1730.83 1244,1754.5C 1241.83,1762.19 1239.83,1769.85 1238,1777.5C 1236.79,1768.98 1234.79,1760.64 1232,1752.5C 1210.33,1730.17 1188.67,1707.83 1167,1685.5C 1148.08,1664.91 1132.74,1641.91 1121,1616.5C 1115.01,1601.71 1111.51,1586.38 1110.5,1570.5C 1120.13,1578.29 1128.96,1586.96 1137,1596.5C 1154.32,1619.13 1170.65,1642.47 1186,1666.5C 1189.47,1670.97 1193.3,1675.13 1197.5,1679C 1211.4,1687.64 1219.9,1683.81 1223,1667.5C 1222.91,1640.8 1217.58,1615.13 1207,1590.5C 1191.14,1554.84 1169.97,1522.84 1143.5,1494.5C 1148.35,1489.49 1153.68,1484.99 1159.5,1481C 1174.87,1471.21 1191.54,1464.54 1209.5,1461C 1256.61,1453.6 1297.94,1465.43 1333.5,1496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 1110.5,1570.5 C 1111.51,1586.38 1115.01,1601.71 1121,1616.5C 1132.74,1641.91 1148.08,1664.91 1167,1685.5C 1188.67,1707.83 1210.33,1730.17 1232,1752.5C 1234.79,1760.64 1236.79,1768.98 1238,1777.5C 1239.83,1769.85 1241.83,1762.19 1244,1754.5C 1267,1730.83 1290,1707.17 1313,1683.5C 1322.49,1671.86 1331.49,1659.86 1340,1647.5C 1354.78,1625 1363.28,1600.33 1365.5,1573.5C 1386.64,1553.09 1411.31,1538.59 1439.5,1530C 1450.37,1547.63 1454.87,1566.8 1453,1587.5C 1448.04,1613.42 1436.71,1636.09 1419,1655.5C 1394.46,1680.34 1366.96,1701.17 1336.5,1718C 1311.83,1731.67 1287.17,1745.33 1262.5,1759C 1253.44,1770.24 1245.77,1782.41 1239.5,1795.5C 1233.72,1782.11 1226.06,1769.94 1216.5,1759C 1187.83,1743 1159.17,1727 1130.5,1711C 1104.88,1696.09 1081.72,1677.92 1061,1656.5C 1044.82,1639.48 1033.82,1619.48 1028,1596.5C 1022.9,1572.86 1026.73,1550.86 1039.5,1530.5C 1066.13,1538.32 1089.8,1551.65 1110.5,1570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 886.5,1933.5 C 901.464,1931.52 916.797,1930.85 932.5,1931.5C 950.42,1980.09 968.253,2028.76 986,2077.5C 999.333,2042.17 1012.67,2006.83 1026,1971.5C 1037.04,1941.27 1058.54,1925.6 1090.5,1924.5C 1055.77,2018.52 1020.94,2112.52 986,2206.5C 952.73,2115.52 919.563,2024.52 886.5,1933.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4399",
    d: "M 1431.5,1927.5 C 1489.36,1923.51 1534.19,1945.51 1566,1993.5C 1585.58,2030.68 1588.91,2069.34 1576,2109.5C 1555.01,2159.81 1517.51,2189.31 1463.5,2198C 1438.5,2198.5 1413.5,2198.67 1388.5,2198.5C 1388.17,2111.5 1388.5,2024.5 1389.5,1937.5C 1403.12,1932.02 1417.12,1928.68 1431.5,1927.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 1806.5,2197.5 C 1791.01,2198.5 1775.34,2198.83 1759.5,2198.5C 1752.02,2180.02 1744.35,2161.52 1736.5,2143C 1706.5,2142.5 1676.5,2142.33 1646.5,2142.5C 1637.07,2176.1 1615.4,2196.93 1581.5,2205C 1578.83,2205.67 1576.17,2205.67 1573.5,2205C 1612.73,2111.8 1652.07,2018.63 1691.5,1925.5C 1730.22,2016 1768.56,2106.67 1806.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4399",
    d: "M 1210.5,1929.5 C 1258.35,1926.61 1298.85,1942.28 1332,1976.5C 1369.91,2023.85 1375.58,2074.85 1349,2129.5C 1325.67,2169.13 1291.17,2192.63 1245.5,2200C 1182.2,2205.93 1134.37,2181.77 1102,2127.5C 1076.53,2073.33 1082.53,2023 1120,1976.5C 1144.77,1950.37 1174.93,1934.7 1210.5,1929.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c72b1",
    d: "M 390.5,1931.5 C 415.337,1930.17 440.337,1930.17 465.5,1931.5C 465.376,1932.11 465.043,1932.44 464.5,1932.5C 440.006,1931.5 415.339,1931.17 390.5,1931.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ddcfe4",
    d: "M 932.5,1931.5 C 916.797,1930.85 901.464,1931.52 886.5,1933.5C 885.596,1932.79 885.263,1931.79 885.5,1930.5C 901.342,1930.17 917.009,1930.5 932.5,1931.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 390.5,1931.5 C 415.339,1931.17 440.006,1931.5 464.5,1932.5C 454.916,1953.91 438.583,1967.07 415.5,1972C 406.159,1972.96 396.825,1973.96 387.5,1975C 367.013,1983.81 361.513,1998.31 371,2018.5C 375.548,2024.52 381.381,2028.69 388.5,2031C 428.266,2033.93 455.433,2053.77 470,2090.5C 479.483,2131.41 466.983,2163.57 432.5,2187C 403.949,2203.17 375.282,2203.51 346.5,2188C 334.964,2180.41 326.631,2170.24 321.5,2157.5C 344.833,2156.83 368.167,2156.17 391.5,2155.5C 411.409,2152.43 423.909,2141.09 429,2121.5C 430.11,2099.93 420.61,2085.1 400.5,2077C 380.248,2075.53 362.248,2068.53 346.5,2056C 323.336,2034.51 316.503,2008.67 326,1978.5C 338.679,1950.65 360.179,1934.98 390.5,1931.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 711.5,2197.5 C 696.009,2198.5 680.342,2198.83 664.5,2198.5C 657.167,2180.5 649.833,2162.5 642.5,2144.5C 627.849,2143.17 612.849,2142.5 597.5,2142.5C 582.33,2142.5 567.33,2142.83 552.5,2143.5C 546.661,2161.33 536.661,2176.49 522.5,2189C 509.71,2199.49 495.043,2204.82 478.5,2205C 517.871,2111.76 557.371,2018.59 597,1925.5C 635.455,2016.07 673.622,2106.74 711.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 885.5,2197.5 C 867.007,2198.5 848.341,2198.83 829.5,2198.5C 805.938,2170.39 782.605,2142.06 759.5,2113.5C 759.44,2112.96 759.107,2112.62 758.5,2112.5C 757.184,2118.32 757.184,2123.99 758.5,2129.5C 758.833,2154.51 758.5,2179.51 757.5,2204.5C 735.519,2195.02 721.685,2178.69 716,2155.5C 714.518,2080.86 714.018,2006.2 714.5,1931.5C 741.169,1931.33 767.835,1931.5 794.5,1932C 844.048,1938.05 871.048,1965.88 875.5,2015.5C 871.649,2060.52 847.649,2088.02 803.5,2098C 830.668,2131.33 858.001,2164.5 885.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 1885.5,2065.5 C 1885.17,2112.01 1884.17,2158.34 1882.5,2204.5C 1858.25,2193.72 1844.42,2175.05 1841,2148.5C 1840.67,2119.5 1840.33,2090.5 1840,2061.5C 1833.62,2027.87 1815.78,2002.37 1786.5,1985C 1779.9,1981.08 1772.9,1978.25 1765.5,1976.5C 1765.5,1961.5 1765.5,1946.5 1765.5,1931.5C 1791.67,1937.42 1815,1948.92 1835.5,1966C 1851.4,1980.31 1860.57,1998.14 1863,2019.5C 1865.44,2005.18 1870.44,1991.85 1878,1979.5C 1899.87,1954.64 1927.04,1938.64 1959.5,1931.5C 1959.5,1946.5 1959.5,1961.5 1959.5,1976.5C 1923,1988.84 1899.16,2013.5 1888,2050.5C 1886.95,2055.47 1886.12,2060.47 1885.5,2065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c4299",
    d: "M 2042.5,1926.5 C 2044.34,1927.12 2045.5,1928.46 2046,1930.5C 2083.4,2019.54 2120.9,2108.54 2158.5,2197.5C 2142.5,2198.83 2126.5,2198.83 2110.5,2197.5C 2103.36,2179.42 2096.03,2161.42 2088.5,2143.5C 2058.5,2142.17 2028.5,2142.17 1998.5,2143.5C 1988.04,2178.3 1965.04,2198.97 1929.5,2205.5C 1928.17,2205.17 1926.83,2204.83 1925.5,2204.5C 1964.52,2111.81 2003.52,2019.14 2042.5,1926.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1433.5,1968.5 C 1478.2,1966.59 1511.03,1985.26 1532,2024.5C 1547.31,2064.34 1540.15,2099.51 1510.5,2130C 1488.48,2149.06 1462.81,2157.9 1433.5,2156.5C 1433.5,2093.83 1433.5,2031.17 1433.5,1968.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1213.5,1972.5 C 1260.81,1969.39 1294.64,1989.06 1315,2031.5C 1329.67,2080.15 1315.84,2118.32 1273.5,2146C 1230.21,2167.2 1191.04,2161.37 1156,2128.5C 1127.01,2094.23 1123.01,2057.23 1144,2017.5C 1160.78,1992.54 1183.94,1977.54 1213.5,1972.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 758.5,1974.5 C 772.212,1974.12 785.879,1974.62 799.5,1976C 821.812,1982.98 832.312,1998.15 831,2021.5C 823.806,2047.67 806.64,2059.17 779.5,2056C 771.69,2053.85 764.856,2050.01 759,2044.5C 758.5,2021.17 758.333,1997.84 758.5,1974.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfd",
    d: "M 623.5,2097.5 C 605.864,2099.49 587.864,2100.15 569.5,2099.5C 578.375,2077.41 587.542,2055.41 597,2033.5C 606.319,2054.62 615.152,2075.95 623.5,2097.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfd",
    d: "M 1718.5,2098.5 C 1700.67,2099.5 1682.67,2099.83 1664.5,2099.5C 1673.37,2077.4 1682.53,2055.4 1692,2033.5C 1701.4,2054.96 1710.23,2076.63 1718.5,2098.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfd",
    d: "M 2070.5,2098.5 C 2052.67,2099.5 2034.67,2099.83 2016.5,2099.5C 2024.99,2077.21 2034.15,2055.21 2044,2033.5C 2053.13,2055.07 2061.97,2076.74 2070.5,2098.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9fcb",
    d: "M 1885.5,2065.5 C 1885.5,2112.17 1885.5,2158.83 1885.5,2205.5C 1884.21,2205.74 1883.21,2205.4 1882.5,2204.5C 1884.17,2158.34 1885.17,2112.01 1885.5,2065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bda1cc",
    d: "M 623.5,2097.5 C 624.404,2098.21 624.737,2099.21 624.5,2100.5C 605.992,2100.83 587.659,2100.5 569.5,2099.5C 587.864,2100.15 605.864,2099.49 623.5,2097.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bda0cc",
    d: "M 1718.5,2098.5 C 1719.04,2098.56 1719.38,2098.89 1719.5,2099.5C 1701,2100.83 1682.67,2100.83 1664.5,2099.5C 1682.67,2099.83 1700.67,2099.5 1718.5,2098.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9fcb",
    d: "M 2070.5,2098.5 C 2071.04,2098.56 2071.38,2098.89 2071.5,2099.5C 2053,2100.83 2034.67,2100.83 2016.5,2099.5C 2034.67,2099.83 2052.67,2099.5 2070.5,2098.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9b70b1",
    d: "M 759.5,2113.5 C 758.512,2118.64 758.179,2123.97 758.5,2129.5C 757.184,2123.99 757.184,2118.32 758.5,2112.5C 759.107,2112.62 759.44,2112.96 759.5,2113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ddd0e4",
    d: "M 552.5,2143.5 C 567.33,2142.83 582.33,2142.5 597.5,2142.5C 612.849,2142.5 627.849,2143.17 642.5,2144.5C 612.574,2143.51 582.574,2143.17 552.5,2143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc9fcb",
    d: "M 391.5,2155.5 C 368.167,2156.17 344.833,2156.83 321.5,2157.5C 320.957,2157.44 320.624,2157.11 320.5,2156.5C 344.157,2155.5 367.824,2155.17 391.5,2155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ddd0e4",
    d: "M 711.5,2197.5 C 712.043,2197.56 712.376,2197.89 712.5,2198.5C 696.338,2199.83 680.338,2199.83 664.5,2198.5C 680.342,2198.83 696.009,2198.5 711.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d70b1",
    d: "M 885.5,2197.5 C 886.043,2197.56 886.376,2197.89 886.5,2198.5C 867.338,2199.83 848.338,2199.83 829.5,2198.5C 848.341,2198.83 867.007,2198.5 885.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ded1e5",
    d: "M 1806.5,2197.5 C 1807.04,2197.56 1807.38,2197.89 1807.5,2198.5C 1791.34,2199.83 1775.34,2199.83 1759.5,2198.5C 1775.34,2198.83 1791.01,2198.5 1806.5,2197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878b8e",
    d: "M 493.5,2258.5 C 483.167,2258.5 472.833,2258.5 462.5,2258.5C 462.5,2267.17 462.5,2275.83 462.5,2284.5C 472.833,2284.5 483.167,2284.5 493.5,2284.5C 493.5,2289.17 493.5,2293.83 493.5,2298.5C 483.167,2298.5 472.833,2298.5 462.5,2298.5C 462.5,2309.5 462.5,2320.5 462.5,2331.5C 473.167,2331.5 483.833,2331.5 494.5,2331.5C 494.5,2336.5 494.5,2341.5 494.5,2346.5C 479.5,2346.5 464.5,2346.5 449.5,2346.5C 449.5,2312.5 449.5,2278.5 449.5,2244.5C 464.167,2244.5 478.833,2244.5 493.5,2244.5C 493.5,2249.17 493.5,2253.83 493.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3c4c6",
    d: "M 1307.5,2244.5 C 1308.83,2279.67 1308.83,2315 1307.5,2350.5C 1306.89,2350.38 1306.56,2350.04 1306.5,2349.5C 1307.5,2314.67 1307.83,2279.67 1307.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 1369.5,2346.5 C 1369.5,2317.17 1369.5,2287.83 1369.5,2258.5C 1362.5,2258.5 1355.5,2258.5 1348.5,2258.5C 1348.5,2253.83 1348.5,2249.17 1348.5,2244.5C 1366.83,2244.5 1385.17,2244.5 1403.5,2244.5C 1403.5,2249.17 1403.5,2253.83 1403.5,2258.5C 1396.5,2258.5 1389.5,2258.5 1382.5,2258.5C 1382.5,2287.83 1382.5,2317.17 1382.5,2346.5C 1378.17,2346.5 1373.83,2346.5 1369.5,2346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a5a7",
    d: "M 1951.5,2244.5 C 1952.66,2279.66 1952.83,2315 1952,2350.5C 1950.96,2349.63 1950.12,2348.63 1949.5,2347.5C 1951.49,2313.52 1952.16,2279.18 1951.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878a8d",
    d: "M 836.5,2242.5 C 861.172,2241.02 877.172,2252.19 884.5,2276C 891.277,2300.22 886.277,2321.55 869.5,2340C 846.844,2355.57 827.677,2352.07 812,2329.5C 803.976,2314.48 801.309,2298.48 804,2281.5C 807.88,2262.47 818.713,2249.47 836.5,2242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 932.5,2244.5 C 942.172,2244.33 951.839,2244.5 961.5,2245C 971.749,2246.92 977.583,2253.08 979,2263.5C 980.86,2274.17 979.193,2284.17 974,2293.5C 971.441,2296.53 968.274,2298.7 964.5,2300C 957.842,2300.5 951.175,2300.67 944.5,2300.5C 944.5,2315.83 944.5,2331.17 944.5,2346.5C 940.5,2346.5 936.5,2346.5 932.5,2346.5C 932.5,2312.5 932.5,2278.5 932.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#85898c",
    d: "M 1507.5,2244.5 C 1522.17,2244.5 1536.83,2244.5 1551.5,2244.5C 1551.5,2249.17 1551.5,2253.83 1551.5,2258.5C 1541.17,2258.5 1530.83,2258.5 1520.5,2258.5C 1520.5,2267.17 1520.5,2275.83 1520.5,2284.5C 1530.83,2284.5 1541.17,2284.5 1551.5,2284.5C 1551.5,2289.17 1551.5,2293.83 1551.5,2298.5C 1541.17,2298.5 1530.83,2298.5 1520.5,2298.5C 1520.5,2314.5 1520.5,2330.5 1520.5,2346.5C 1516.17,2346.5 1511.83,2346.5 1507.5,2346.5C 1507.5,2312.5 1507.5,2278.5 1507.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 651.5,2283.5 C 661.319,2284.49 671.319,2284.83 681.5,2284.5C 680.167,2289.17 680.167,2293.83 681.5,2298.5C 671.319,2298.17 661.319,2298.51 651.5,2299.5C 651.5,2310.17 651.5,2320.83 651.5,2331.5C 661.833,2331.5 672.167,2331.5 682.5,2331.5C 682.5,2336.5 682.5,2341.5 682.5,2346.5C 667.833,2346.5 653.167,2346.5 638.5,2346.5C 638.5,2312.5 638.5,2278.5 638.5,2244.5C 653.167,2244.5 667.833,2244.5 682.5,2244.5C 682.5,2249.17 682.5,2253.83 682.5,2258.5C 672.167,2258.5 661.833,2258.5 651.5,2258.5C 651.5,2266.83 651.5,2275.17 651.5,2283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 727.5,2244.5 C 731.833,2244.5 736.167,2244.5 740.5,2244.5C 740.5,2273.5 740.5,2302.5 740.5,2331.5C 750.167,2331.5 759.833,2331.5 769.5,2331.5C 769.5,2336.5 769.5,2341.5 769.5,2346.5C 755.5,2346.5 741.5,2346.5 727.5,2346.5C 727.5,2312.5 727.5,2278.5 727.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 1161.5,2258.5 C 1160.51,2266.98 1160.17,2275.65 1160.5,2284.5C 1170.83,2284.5 1181.17,2284.5 1191.5,2284.5C 1191.5,2289.17 1191.5,2293.83 1191.5,2298.5C 1181.17,2298.5 1170.83,2298.5 1160.5,2298.5C 1160.17,2309.68 1160.51,2320.68 1161.5,2331.5C 1171.83,2331.5 1182.17,2331.5 1192.5,2331.5C 1192.5,2336.5 1192.5,2341.5 1192.5,2346.5C 1177.83,2346.5 1163.17,2346.5 1148.5,2346.5C 1148.5,2312.5 1148.5,2278.5 1148.5,2244.5C 1162.83,2244.5 1177.17,2244.5 1191.5,2244.5C 1191.5,2249.17 1191.5,2253.83 1191.5,2258.5C 1181.5,2258.5 1171.5,2258.5 1161.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86898c",
    d: "M 1596.5,2244.5 C 1600.83,2244.5 1605.17,2244.5 1609.5,2244.5C 1609.5,2278.5 1609.5,2312.5 1609.5,2346.5C 1605.17,2346.5 1600.83,2346.5 1596.5,2346.5C 1596.5,2312.5 1596.5,2278.5 1596.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86898d",
    d: "M 1715.5,2312.5 C 1715.78,2313.29 1716.28,2313.96 1717,2314.5C 1717.5,2291.17 1717.67,2267.84 1717.5,2244.5C 1721.17,2244.5 1724.83,2244.5 1728.5,2244.5C 1728.83,2279.34 1728.5,2314 1727.5,2348.5C 1707.77,2325.26 1688.93,2301.26 1671,2276.5C 1670.5,2299.83 1670.33,2323.16 1670.5,2346.5C 1666.5,2346.5 1662.5,2346.5 1658.5,2346.5C 1658.33,2311.17 1658.5,2275.83 1659,2240.5C 1678.43,2264.09 1697.26,2288.09 1715.5,2312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86898d",
    d: "M 1938.5,2312.5 C 1938.78,2313.29 1939.28,2313.96 1940,2314.5C 1940.5,2291.17 1940.67,2267.84 1940.5,2244.5C 1944.17,2244.5 1947.83,2244.5 1951.5,2244.5C 1952.16,2279.18 1951.49,2313.52 1949.5,2347.5C 1933.58,2327.35 1917.41,2307.35 1901,2287.5C 1898.42,2284 1896.08,2280.34 1894,2276.5C 1893.5,2299.83 1893.33,2323.16 1893.5,2346.5C 1889.5,2346.5 1885.5,2346.5 1881.5,2346.5C 1881.33,2311.17 1881.5,2275.83 1882,2240.5C 1901.43,2264.09 1920.26,2288.09 1938.5,2312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 2124.5,2258.5 C 2123.51,2266.98 2123.17,2275.65 2123.5,2284.5C 2133.83,2284.5 2144.17,2284.5 2154.5,2284.5C 2154.5,2289.17 2154.5,2293.83 2154.5,2298.5C 2144.17,2298.5 2133.83,2298.5 2123.5,2298.5C 2123.5,2309.83 2123.5,2321.17 2123.5,2332.5C 2133.83,2332.5 2144.17,2332.5 2154.5,2332.5C 2154.5,2337.17 2154.5,2341.83 2154.5,2346.5C 2139.83,2346.5 2125.17,2346.5 2110.5,2346.5C 2110.5,2312.5 2110.5,2278.5 2110.5,2244.5C 2125.17,2244.5 2139.83,2244.5 2154.5,2244.5C 2154.5,2249.17 2154.5,2253.83 2154.5,2258.5C 2144.5,2258.5 2134.5,2258.5 2124.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e2",
    d: "M 1238.5,2241.5 C 1237.5,2276.33 1237.17,2311.33 1237.5,2346.5C 1236.17,2311.33 1236.17,2276 1237.5,2240.5C 1238.11,2240.62 1238.44,2240.96 1238.5,2241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e2",
    d: "M 1717.5,2244.5 C 1717.67,2267.84 1717.5,2291.17 1717,2314.5C 1716.28,2313.96 1715.78,2313.29 1715.5,2312.5C 1716.17,2289.83 1716.83,2267.17 1717.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a5a7",
    d: "M 1728.5,2244.5 C 1729.66,2279.66 1729.83,2315 1729,2350.5C 1728.28,2349.96 1727.78,2349.29 1727.5,2348.5C 1728.5,2314 1728.83,2279.34 1728.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e2",
    d: "M 1940.5,2244.5 C 1940.67,2267.84 1940.5,2291.17 1940,2314.5C 1939.28,2313.96 1938.78,2313.29 1938.5,2312.5C 1939.17,2289.83 1939.83,2267.17 1940.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 839.5,2257.5 C 857.706,2258.19 868.873,2267.53 873,2285.5C 875.87,2301.86 871.703,2316.02 860.5,2328C 845.631,2337.33 833.131,2334.83 823,2320.5C 815.332,2305.48 814.665,2290.14 821,2274.5C 825.484,2266.84 831.651,2261.18 839.5,2257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d8da",
    d: "M 493.5,2258.5 C 483.681,2259.49 473.681,2259.83 463.5,2259.5C 463.5,2267.5 463.5,2275.5 463.5,2283.5C 473.681,2283.17 483.681,2283.51 493.5,2284.5C 483.167,2284.5 472.833,2284.5 462.5,2284.5C 462.5,2275.83 462.5,2267.17 462.5,2258.5C 472.833,2258.5 483.167,2258.5 493.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 945.5,2258.5 C 963.116,2256.94 969.616,2264.61 965,2281.5C 963.833,2282.67 962.667,2283.83 961.5,2285C 956.264,2286.34 950.93,2286.84 945.5,2286.5C 945.5,2277.17 945.5,2267.83 945.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878b8e",
    d: "M 529.5,2244.5 C 534.167,2244.5 538.833,2244.5 543.5,2244.5C 550.168,2266.83 557.001,2289.16 564,2311.5C 571.755,2289.33 578.922,2267 585.5,2244.5C 590.179,2244.33 594.845,2244.5 599.5,2245C 588.071,2279.95 576.237,2314.79 564,2349.5C 552.196,2314.59 540.696,2279.59 529.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e2",
    d: "M 1348.5,2258.5 C 1355.5,2258.5 1362.5,2258.5 1369.5,2258.5C 1369.5,2287.83 1369.5,2317.17 1369.5,2346.5C 1368.5,2317.67 1368.17,2288.67 1368.5,2259.5C 1361.65,2259.82 1354.98,2259.49 1348.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 337.5,2244.5 C 386.301,2236.8 408.468,2257.47 404,2306.5C 402.618,2319.76 397.118,2330.93 387.5,2340C 382.765,2343.52 377.432,2345.52 371.5,2346C 360.172,2346.5 348.838,2346.67 337.5,2346.5C 337.5,2312.5 337.5,2278.5 337.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 350.5,2259.5 C 377.852,2255.69 391.185,2267.52 390.5,2295C 391.603,2323.07 378.27,2335.23 350.5,2331.5C 350.5,2307.5 350.5,2283.5 350.5,2259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878b8e",
    d: "M 2029.5,2242.5 C 2042.57,2240.04 2054.07,2243.04 2064,2251.5C 2064.67,2257.5 2064.67,2263.5 2064,2269.5C 2050.74,2255.17 2036.4,2253.84 2021,2265.5C 2011.45,2279.14 2008.78,2294.14 2013,2310.5C 2020.64,2333.4 2035.14,2339.23 2056.5,2328C 2059.28,2326.19 2061.78,2324.02 2064,2321.5C 2064.67,2327.83 2064.67,2334.17 2064,2340.5C 2044.57,2353.92 2026.57,2352.26 2010,2335.5C 1995.78,2313.27 1993.78,2289.94 2004,2265.5C 2009.88,2254.78 2018.38,2247.11 2029.5,2242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#868a8d",
    d: "M 1238.5,2241.5 C 1257.41,2264.98 1276.07,2288.65 1294.5,2312.5C 1294.78,2313.29 1295.28,2313.96 1296,2314.5C 1296.5,2291.17 1296.67,2267.84 1296.5,2244.5C 1300.17,2244.5 1303.83,2244.5 1307.5,2244.5C 1307.83,2279.67 1307.5,2314.67 1306.5,2349.5C 1289.88,2328.37 1273.05,2307.37 1256,2286.5C 1253.65,2283.81 1251.82,2280.81 1250.5,2277.5C 1250.44,2276.96 1250.11,2276.62 1249.5,2276.5C 1248.5,2299.82 1248.17,2323.16 1248.5,2346.5C 1244.83,2346.5 1241.17,2346.5 1237.5,2346.5C 1237.17,2311.33 1237.5,2276.33 1238.5,2241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4a5a7",
    d: "M 1250.5,2277.5 C 1249.83,2300.5 1249.17,2323.5 1248.5,2346.5C 1248.17,2323.16 1248.5,2299.82 1249.5,2276.5C 1250.11,2276.62 1250.44,2276.96 1250.5,2277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c3c5",
    d: "M 1296.5,2244.5 C 1296.67,2267.84 1296.5,2291.17 1296,2314.5C 1295.28,2313.96 1294.78,2313.29 1294.5,2312.5C 1295.17,2289.83 1295.83,2267.17 1296.5,2244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c3c5",
    d: "M 1161.5,2258.5 C 1161.5,2266.83 1161.5,2275.17 1161.5,2283.5C 1171.68,2283.17 1181.68,2283.51 1191.5,2284.5C 1181.17,2284.5 1170.83,2284.5 1160.5,2284.5C 1160.17,2275.65 1160.51,2266.98 1161.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c3c5",
    d: "M 2124.5,2258.5 C 2124.5,2266.83 2124.5,2275.17 2124.5,2283.5C 2134.68,2283.17 2144.68,2283.51 2154.5,2284.5C 2144.17,2284.5 2133.83,2284.5 2123.5,2284.5C 2123.17,2275.65 2123.51,2266.98 2124.5,2258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#acaeb0",
    d: "M 651.5,2283.5 C 661.833,2283.5 672.167,2283.5 682.5,2283.5C 682.5,2288.83 682.5,2294.17 682.5,2299.5C 672.167,2299.5 661.833,2299.5 651.5,2299.5C 661.319,2298.51 671.319,2298.17 681.5,2298.5C 680.167,2293.83 680.167,2289.17 681.5,2284.5C 671.319,2284.83 661.319,2284.49 651.5,2283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2c3c5",
    d: "M 1191.5,2298.5 C 1181.68,2299.49 1171.68,2299.83 1161.5,2299.5C 1161.5,2310.17 1161.5,2320.83 1161.5,2331.5C 1160.51,2320.68 1160.17,2309.68 1160.5,2298.5C 1170.83,2298.5 1181.17,2298.5 1191.5,2298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878a8d",
    d: "M 1804.5,2241.5 C 1805.75,2241.58 1806.58,2242.24 1807,2243.5C 1818.88,2277.64 1831.04,2311.64 1843.5,2345.5C 1838.83,2346.83 1834.17,2346.83 1829.5,2345.5C 1826.83,2337.14 1824.16,2328.81 1821.5,2320.5C 1810.81,2320.17 1800.15,2320.5 1789.5,2321.5C 1786.42,2329.74 1783.75,2338.07 1781.5,2346.5C 1776.83,2346.5 1772.17,2346.5 1767.5,2346.5C 1779.64,2311.43 1791.97,2276.43 1804.5,2241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 1804.5,2275.5 C 1805.5,2275.47 1806.16,2275.97 1806.5,2277C 1809.14,2286.74 1812.48,2296.24 1816.5,2305.5C 1809.17,2306.83 1801.83,2306.83 1794.5,2305.5C 1798.44,2295.69 1801.77,2285.69 1804.5,2275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878b8e",
    d: "M 1032.5,2240.5 C 1033.12,2240.61 1033.62,2240.94 1034,2241.5C 1043,2266.51 1052,2291.51 1061,2316.5C 1069.7,2291.01 1078.7,2265.68 1088,2240.5C 1094.59,2275.79 1100.75,2311.12 1106.5,2346.5C 1102.5,2346.5 1098.5,2346.5 1094.5,2346.5C 1091.18,2326.21 1088.01,2305.87 1085,2285.5C 1077.29,2307.26 1069.29,2328.92 1061,2350.5C 1052.62,2329.36 1044.62,2308.02 1037,2286.5C 1032.97,2306.33 1029.47,2326.33 1026.5,2346.5C 1022.5,2346.5 1018.5,2346.5 1014.5,2346.5C 1020.78,2311.21 1026.78,2275.88 1032.5,2240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4b5b7",
    d: "M 2154.5,2298.5 C 2144.68,2299.49 2134.68,2299.83 2124.5,2299.5C 2124.5,2310.17 2124.5,2320.83 2124.5,2331.5C 2134.83,2331.5 2145.17,2331.5 2155.5,2331.5C 2155.82,2336.69 2155.49,2341.69 2154.5,2346.5C 2154.5,2341.83 2154.5,2337.17 2154.5,2332.5C 2144.17,2332.5 2133.83,2332.5 2123.5,2332.5C 2123.5,2321.17 2123.5,2309.83 2123.5,2298.5C 2133.83,2298.5 2144.17,2298.5 2154.5,2298.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdfEnglish);
export default __webpack_public_path__ + "static/media/SDF English.d1d29252795f20309caeb5a0c9b64033.svg";
export { ForwardRef as ReactComponent };